import MuiDivider from '@mui/material/Divider';
import type { DividerProps } from './IDivider';
import { styles } from './styles';

const Divider = ({ sx, ...rest }: DividerProps) => (
    <MuiDivider
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default Divider;
